import { PredefinedAreaRole } from '../types/roles';

export const predefinedRoles: PredefinedAreaRole[] = [
  /**
   *  If you want to add a new predefined role you should add a new item to this array.
   *  Predefined Role Fields:
   *  {
   *    // policy id
   *    id: '6600344267119876119'
   *
   *    // deprecatedKey
   *    deprecatedKey: 'backOfficeManager'
   *
   *    // localized key of the role title, you must add this key and a value to messages_en.json
   *    // value format: 'role.${roleKey}.title'
   *    titleKey: 'role.backOfficeManager.title',
   *
   *    // localized key of the role description, you must add this key and a value to messages_en.json
   *    // value format: `role.${roleKey}.desc`
   *    descriptionKey: 'role.backOfficeManager.desc',
   *
   *
   *    // optional
   *    // if restrictFromLevel == 'site', this role won't be part of the site (contributors) roles
   *    // if restrictFromLevel == 'account', this role won't be part of the account (team) roles
   *    // 'site' or 'account'
   *    restrictFromLevel?: 'site'
   *
   *    // optional
   *    // only for site level (contributors)
   *    // the role will be displayed only if at least one app from the appDefIds array was added to the site
   *    // for predefined appDefIds please see https://github.com/wix-private/business-manager/blob/master/business-manager-api/src/appDefIds.ts
   *    appDefIds?: ['bfa8c45b-be27-490c-93a8-82a337eae912']
   *
   *    // optional
   *    // experiments for this role
   *    // the role will be displayed only if one of the experiments is on
   *    // account manager scope - 'account-manager'
   *    // site manager scope - 'business-manager'
   *    experiments?: ['specs.wos.DisplayScope']
   *
   *    // optional
   *    // set true if you want to prevent the user from assigning this role
   *    // Warning!!: if deprecated == true, this role won't be assignable in the invite and change role pages
   *    // true or false (default)
   *    deprecated?: false,
   *  }
   *
   *  NOTE: The order of the array affect the way we present the roles list.
   *
   * */
  {
    titleKey: 'role.area.title.general',
    roles: [
      {
        id: '6601492336091027458',
        deprecatedKey: 'owner',
        titleKey: 'role.owner.title',
        descriptionKey: 'role.owner.desc',
        deprecated: true,
      },
      {
        id: '6642345101181663232',
        deprecatedKey: 'accountCoOwner',
        titleKey: 'role.accountCoOwner.title',
        descriptionKey: 'role.accountCoOwner.desc',
        restrictFromLevel: 'site',
        experiments: ['specs.ident.DisplayAccountCoOwnerRole'],
      },
      {
        id: '6600343328279451657',
        deprecatedKey: 'admin',
        titleKey: 'role.admin.title',
        descriptionKey: 'role.admin.desc',
        restrictFromLevel: 'account',
      },
      {
        id: '6600343568810203151',
        deprecatedKey: 'limitedAdmin',
        titleKey: 'role.limitedAdmin.title',
        descriptionKey: 'role.limitedAdmin.desc',
        restrictFromLevel: 'account',
        deprecated: true,
      },
      {
        id: '6643122506063252487',
        deprecatedKey: 'accountAdmin',
        titleKey: 'role.accountAdmin.title',
        descriptionKey: 'role.accountAdmin.desc',
        restrictFromLevel: 'site',
      },
      {
        id: '6643122648174660618',
        deprecatedKey: 'accountLimitedAdmin',
        titleKey: 'role.accountLimitedAdmin.title',
        descriptionKey: 'role.accountLimitedAdmin.desc',
        restrictFromLevel: 'site',
        deprecated: true,
      },
      {
        id: '6600343671872641041',
        deprecatedKey: 'websiteManager',
        titleKey: 'role.websiteManager.title',
        descriptionKey: 'role.websiteManager.desc',
        restrictFromLevel: 'account',
      },
      {
        id: '6600342285084743683',
        deprecatedKey: 'limitedWebsiteManager',
        titleKey: 'role.limitedWebsiteManager.title',
        descriptionKey: 'role.limitedWebsiteManager.desc',
        restrictFromLevel: 'account',
        deprecated: true,
      },
      {
        id: '6643122105421848577',
        deprecatedKey: 'accountWebsiteManager',
        titleKey: 'role.accountWebsiteManager.title',
        descriptionKey: 'role.accountWebsiteManager.desc',
        restrictFromLevel: 'site',
      },
      {
        id: '6643121764183149571',
        deprecatedKey: 'accountLimitedWebsiteManager',
        titleKey: 'role.accountLimitedWebsiteManager.title',
        descriptionKey: 'role.accountLimitedWebsiteManager.desc',
        restrictFromLevel: 'site',
        deprecated: true,
      },
      {
        id: '6600344267119876119',
        deprecatedKey: 'backOfficeManager',
        titleKey: 'role.backOfficeManager.title',
        descriptionKey: 'role.backOfficeManager.desc',
      },
    ],
  },
  {
    titleKey: 'role.area.title.stores',
    roles: [
      {
        id: '6690545134479579136',
        deprecatedKey: 'storeManagerNew',
        titleKey: 'role.storeManagerNew.title',
        descriptionKey: 'role.storeManagerNew.desc',
        restrictFromLevel: 'account',
        experiments: ['specs.ident.DisplayStoreManagerNewRole'],
      },
    ],
  },
  {
    titleKey: 'role.area.title.billingAndDomains',
    roles: [
      {
        id: '6642345601440495619',
        deprecatedKey: 'billingManager',
        titleKey: 'role.billingManager.title',
        descriptionKey: 'role.billingManager.desc',
        restrictFromLevel: 'site',
        experiments: ['specs.ident.DisplayPremiumRoles'],
      },
      {
        id: '6642345601440495619',
        deprecatedKey: 'billingManager',
        titleKey: 'role.billingManager.title',
        descriptionKey: 'role.billingManager.desc',
        restrictFromLevel: 'account',
        experiments: ['specs.ident.DisplayPremiumRolesInSite'],
      },
      {
        id: '6653312585132492834',
        deprecatedKey: 'domainsManager',
        titleKey: 'role.domainsManager.title',
        descriptionKey: 'role.domainsManager.desc',
        restrictFromLevel: 'site',
        experiments: ['specs.ident.DisplayPremiumRoles'],
      },
      {
        id: '6653312585132492834',
        deprecatedKey: 'domainsManager',
        titleKey: 'role.domainsManager.title',
        descriptionKey: 'role.domainsManager.desc',
        restrictFromLevel: 'account',
        experiments: ['specs.ident.DisplayPremiumRolesInSite']
      },
    ],
  },
  {
    titleKey: 'role.area.title.blog',
    roles: [
      {
        id: '6600344420111308827',
        deprecatedKey: 'blogEditor',
        titleKey: 'role.blogEditor.title',
        descriptionKey: 'role.blogEditor.desc',
        appDefIds: ['14bcded7-0066-7c35-14d7-466cb3f09103'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
      },
      {
        id: '6600343770271012883',
        deprecatedKey: 'blogWriter',
        titleKey: 'role.blogWriter.title',
        descriptionKey: 'role.blogWriter.desc',
        appDefIds: ['14bcded7-0066-7c35-14d7-466cb3f09103'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
      },
    ],
  },
  {
    titleKey: 'role.area.title.bookings',
    roles: [
      {
        id: '6600343826713761813',
        deprecatedKey: 'bookingsAdmin',
        titleKey: 'role.bookingsAdmin.title',
        descriptionKey: 'role.bookingsAdmin.desc',
        appDefIds: ['13d21c63-b5ec-5912-8397-c3a5ddb27a97'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
        restrictFromLevel: 'account',
      },
      {
        id: '6600342952117491717',
        deprecatedKey: 'bookingsStaffMember',
        titleKey: 'role.bookingsStaffMember.title',
        descriptionKey: 'role.bookingsStaffMember.desc',
        appDefIds: ['13d21c63-b5ec-5912-8397-c3a5ddb27a97'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
        restrictFromLevel: 'account',
      },
    ],
  },
  {
    titleKey: 'role.area.title.events',
    roles: [
      {
        id: '6643886139053999104',
        deprecatedKey: 'eventCheckInAssistant',
        titleKey: 'role.eventCheckInAssistant.title',
        descriptionKey: 'role.eventCheckInAssistant.desc',
        appDefIds: ['140603ad-af8d-84a5-2c80-a0f60cb47351'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
        restrictFromLevel: 'account',
      },
    ],
  },
  {
    titleKey: 'role.area.title.pos',
    roles: [
      {
        id: '6600343429693528075',
        deprecatedKey: 'storeManager',
        titleKey: 'role.storeManager.title',
        descriptionKey: 'role.storeManager.desc',
        appDefIds: ['44562f1b-17ec-4907-b242-b76ac06e707a'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
        restrictFromLevel: 'account',
      },
      {
        id: '6600344699300960289',
        deprecatedKey: 'cashierManager',
        titleKey: 'role.cashierManager.title',
        descriptionKey: 'role.cashierManager.desc',
        appDefIds: ['44562f1b-17ec-4907-b242-b76ac06e707a'],
        experiments: ['specs.ident.DisplayRolesWithAppDefIds'],
        restrictFromLevel: 'account',
      },
    ],
  },
  {
    titleKey: 'role.area.title.ntt',
    roles: [
      {
        id: '6600343226248812551',
        deprecatedKey: 'siteAnalyticsViewer',
        titleKey: 'role.siteAnalyticsViewer.title',
        descriptionKey: 'role.siteAnalyticsViewer.desc',
        experiments: ['specs.wos.siteAnalyticsRole'],
      },
      {
        id: '6612722526048361472',
        deprecatedKey: 'customerManager',
        titleKey: 'role.customerManager.title',
        descriptionKey: 'role.customerManager.desc',
        experiments: ['specs.wos1.CRMRolesForNTT'],
      },
      {
        id: '6612723031080311810',
        deprecatedKey: 'customerFinanceManager',
        titleKey: 'role.customerFinanceManager.title',
        descriptionKey: 'role.customerFinanceManager.desc',
        experiments: ['specs.wos1.CRMRolesForNTT'],
      },
    ],
  },
  {
    titleKey: 'role.area.title.payments',
    roles: [
      {
        id: '6668766861715543040',
        deprecatedKey: 'paymentsManager',
        titleKey: 'role.paymentsManager.title',
        descriptionKey: 'role.paymentsManager.desc',
        experiments: ['specs.ident.DisplayPaymentsManagerRole'],
      },
    ],
  }
];
